export default class OperazioneAttivita{
    Eseguito;
    CodiceEsito;
    DescrizioneEsito;
    Descrizione;
    Note;
    SysChiaveglobale;

    constructor(){}
}